export default __webpack_public_path__ + "static/media/24-hours.60c6d118.png";